<div
  class="metro-toast-container"
  [attr.aria-live]="ariaLive()"
  role="status"
>
  @for (toast of toasts(); track trackById($index, toast)) {
    <div
      class="metro-toast"
      [class.metro-toast-success]="toast.severity === 'success'"
      [class.metro-toast-info]="toast.severity === 'info'"
      [class.metro-toast-warning]="toast.severity === 'warning'"
      [class.metro-toast-error]="toast.severity === 'error'"
    >
      <div class="metro-toast-body">
        @if (toast.title) {
          <div class="metro-toast-title">{{ toast.title }}</div>
        }
        <div class="metro-toast-message">{{ toast.message }}</div>
      </div>
    </div>
  }
</div>
